"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var classnames_1 = tslib_1.__importDefault(require("classnames"));
var rc_menu_1 = require("rc-menu");
var omit_1 = tslib_1.__importDefault(require("rc-util/lib/omit"));
var reactNode_1 = require("../../util/reactNode");
var MenuContext_1 = tslib_1.__importDefault(require("./MenuContext"));
var SubMenu = /** @class */ (function (_super) {
    tslib_1.__extends(SubMenu, _super);
    function SubMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubMenu.prototype.renderTitle = function (inlineCollapsed) {
        var _a = this.props, icon = _a.icon, title = _a.title, level = _a.level, rootPrefixCls = _a.rootPrefixCls;
        if (!icon) {
            return inlineCollapsed && level === 1 && title && typeof title === 'string' ? (React.createElement("div", { className: "".concat(rootPrefixCls, "-inline-collapsed-noicon") }, title.charAt(0))) : (title);
        }
        // inline-collapsed.md demo 依赖 span 来隐藏文字,有 icon 属性，则内部包裹一个 span
        // ref: https://github.com/ant-design/ant-design/pull/23456
        var titleIsSpan = (0, reactNode_1.isValidElement)(title) && title.type === 'span';
        return (React.createElement(React.Fragment, null,
            icon,
            titleIsSpan ? title : React.createElement("span", null, title)));
    };
    SubMenu.prototype.render = function () {
        var _this = this;
        // const { rootPrefixCls, popupClassName } = this.props;
        var popupClassName = this.props.popupClassName;
        return (React.createElement(MenuContext_1.default.Consumer, null, function (_a) {
            var inlineCollapsed = _a.inlineCollapsed, antdMenuTheme = _a.antdMenuTheme, prefixCls = _a.prefixCls;
            return (React.createElement(rc_menu_1.SubMenu, tslib_1.__assign({}, (0, omit_1.default)(_this.props, ['icon']), { title: _this.renderTitle(inlineCollapsed), popupClassName: (0, classnames_1.default)(prefixCls, "".concat(prefixCls, "-").concat(antdMenuTheme), popupClassName) })));
        }));
    };
    SubMenu.contextType = MenuContext_1.default;
    // fix issue:https://github.com/ant-design/ant-design/issues/8666
    SubMenu.isSubMenu = 1;
    return SubMenu;
}(React.Component));
exports.default = SubMenu;
//# sourceMappingURL=SubMenu.js.map